import { TableDataQa } from 'commons/types/enums'
import { Page, Panel, PanelFace } from 'ui/components'

import { HistoryTable } from '../../components/HistoryTable/HistoryTable'
import { Filter } from './components'
import { useHistoryAuditList } from './hooks/useHistoryAuditList'

const HistoryAuditList = () => {
  const { data, isRefetching, isFirstFetching, items, setFilter } = useHistoryAuditList()

  return (
    <Page title="Activity Audit" isPending={isFirstFetching}>
      <Panel rounded shadowed collapsible={false} face={PanelFace.SECONDARY}>
        <Filter data={data} setFilter={setFilter} />
        {data && (
          <HistoryTable
            dataQa={TableDataQa.BP_ENTITY_HISTORY_LIST}
            loading={isRefetching}
            items={items}
            historyPagination={{
              onPageSizeChange: (size) => setFilter((prev) => ({ ...prev, size })),
              onNextPage: () => setFilter((prev) => ({ ...prev, lastID: items[items.length - 1].id })),
              size: data?.config.size,
              hasNextPage: data?.hasNextPage || false
            }}
          />
        )}
      </Panel>
    </Page>
  )
}

export default HistoryAuditList
